import { create } from 'zustand';
import type { Asset } from '@scio3/shared-types';

export interface EngageWizardConfig {
  /** Existing asset for edit mode */
  asset?: Partial<Asset> | null;
  /** Current folder context */
  group?: { _id: string; teamId?: string; currentPath?: string } | null;
  /** Skip directly to Step 3 (Build) — used when editing existing assets */
  jumpToBuild?: boolean;
  /** Pre-select a specific AppMetaGroup (from WelcomeEngage card click) */
  appMetaGroupId?: string;
}

interface EngageWizardState {
  isOpen: boolean;
  config: EngageWizardConfig;
  openWizard: (config?: EngageWizardConfig) => void;
  closeWizard: () => void;
}

export const useEngageWizardStore = create<EngageWizardState>((set) => ({
  isOpen: false,
  config: {},
  openWizard: (config = {}) => set({ isOpen: true, config }),
  closeWizard: () => set({ isOpen: false, config: {} }),
}));
